import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_fr';
import Cleave from 'cleave.js';
import 'cleave.js/src/addons/phone-type-formatter.fr';
import { Alert } from '../functions';

// eslint-disable-next-line no-undef
const object = vipersObject;

if ($('.vipers-phone-input').length) {
    new Cleave('.vipers-phone-input', {
        phone: true,
        phoneRegionCode: 'FR',
    });
}

const form = $('.vipers-send-my-form');

form.validate({
    onsubmit: true,
    submitHandler: function (form, event) {
        const $form = $(form);
        var action = $form.attr('action');
        event.preventDefault();
        event.stopPropagation();

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: $form.serialize() + '&action=' + action,
            beforeSend: () => {
                $form.addClass('sending');
                Alert('warning', object.formWait, false);
            },
            success: (res) => {
                $form.removeClass('sending');

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect;
                }

                if (!res.success) {
                    Alert(res.success, res.data.message);
                }
            },
            /*complete: () => {
                if (object.isRecaptcha.active) {
                    // eslint-disable-next-line no-undef
                    grecaptcha.reset();
                }
            },*/
        });
    },
    invalidHandler: () => {
        Alert(false, object.formError, 4000);
    },
});
